import UnderwritersTable from './UnderwritersTable';

export default UnderwritersTable;
